import DashboardAPI from './dashboard-maps'
import DashboardJettyAPI from './dashboard-jetty'
import DashboardBerthingManagementAPI from './dashboard-berthing-management'
import DashboardTrafficInformationAPI from './dashboard-traffic-information'

export {
  DashboardAPI,
  DashboardJettyAPI,
  DashboardBerthingManagementAPI,
  DashboardTrafficInformationAPI,
}
